import _ from "lodash";
import React, { useEffect, useState } from "react";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";
import UIModal from "UIComponents/UIModal";
import DialogueBoxV2 from "UIComponents/DialogueBoxV2";
import StudentAlerts from "AppComponents/StudentAlerts";
import {
  getCriteriaSetOfPypType,
  getCriteriaSetBasedOnPlannerElementType,
} from "modules/Services";
import {
  pypElementMapping,
  pypElementSetMapping,
} from "Constants/plannerElementMappings";

import moment from "moment";

// Redux state management
import { updatePost } from "Post/modules/PostModule";

//scss
import classes from "./PostRateonLearningGoals.scss";

// Rating editor/preview
import PypEvaluationV2 from "AssessmentEvaluation/components/PypEvaluationV2";
//Util
import {
  getIsNewGradingSetupEnabled,
  getNestedTaggedLearningGoalsIds,
} from "Post/utils";
import { checkAchievementCriteriaExists } from "ClassRoom/modules/utils";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
// DS
import {
  Alert,
  Avatar,
  Button,
  Checkbox,
  IconButton,
  SideNavigation,
  ToggleSwitch,
  EmptyState,
  Dropdown,
  DropdownMenu,
} from "@toddle-edu/ds-web";
import {
  CloseOutlined,
  TickCircleFilled,
  CaretDownFilled,
} from "@toddle-edu/ds-icons";
import { connect } from "react-redux";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  TABLET_LANDSCAPE_MEDIA_QUERY,
} from "Constants/stringConstants";
import { colors, NoAssignmentIllustration } from "@toddle-edu/ds-theme";
import classNames from "classnames";
import { getCourseDetailsFromCache } from "Course/modules/CourseGraphqlHelpers";
import {
  getSelectedAcademicYearId,
  getDefaultStudentNameOrderPreference,
} from "modules/CommonSelectors";
import { getFormattedStudentName } from "../../../../../../../Utils/GetFormattedStudentName";
import { getSelectedLearningCourseId } from "Teacher/routes/LearningCourse/modules/Utils";
import { useMediaQuery } from "Hooks";

const BLANK_ARRAY = [];
const PostRateonLearningGoals = props => {
  const {
    students,
    curriculumProgramType,
    showLearningGoalsEditor,
    showLearningGoalsPreview = false,
    setShowPostRatingsModal,
    onCloseClick,
    mappedLearningGoals,
    parentId,
    ibPYPElementRatings, // same value as send in propsIbPypElementRatings
    isStudentIndividuallyRated,
    originalIsStudentIndividuallyRated,
    currentSelectedStudentForRating,
    currentRatings,
    updatePost,
    originalibPYPElementRatings = [],
    hideStudentSelectionNavigation,
    t,
    course,
    showLearningGoalsTheatreModePreview = false,
    currentActiveTerms = [],
    currentActiveTerm,
    postAcademicTermLabel,
    defaultStudentNameOrderPreference,
    learningCourseId,
    learningCourseIdFromProps,
  } = props;
  const MOVE_TO_INDIVIDUAL = "MOVE_TO_INDIVIDUAL";
  const MOVE_TO_COLLECTIVE = "MOVE_TO_COLLECTIVE";
  const CANCEL_RATINGS = "CANCEL_RATINGS";

  const warningTextStyles = {
    backgroundColor: colors.toddleBG2,
    color: colors.textDefault,
    padding: "16px",
    borderRadius: "8px",
    fontSize: "1.6rem",
  };

  const isTablet = useMediaQuery(TABLET_LANDSCAPE_MEDIA_QUERY);
  useEffect(() => {
    // In preview mode or inidividual rate mode (editor), first student should be selected by default
    if (
      showLearningGoalsPreview ||
      (showLearningGoalsEditor && isStudentIndividuallyRated) ||
      _.size(students, 0) == 1
    )
      updatePost({
        currentSelectedStudentForRating: _.get(students, "[0]", {}),
      });

    // used to remove selected student, (caused by preview effect in past).
    if (
      showLearningGoalsEditor &&
      !isStudentIndividuallyRated &&
      _.size(students, 0) > 1
    )
      updatePost({ currentSelectedStudentForRating: {} });
  }, [showLearningGoalsPreview, isStudentIndividuallyRated]);

  const [showCollectiveAlert, setShowCollectiveAlert] = useState(
    !isStudentIndividuallyRated && !showLearningGoalsPreview
  );
  const [showMypAlert, setShowMypAlert] = useState(true);
  const switchTextClass = classNames({
    ["text-label-1"]: !isTablet,
    ["text-label-2"]: isTablet,
    [classes.switchText]: true,
  });

  const getCriteriaSetOfPypTypeWrapper = params => {
    const { getCriteriaSetOfPypType, grades } = props;
    return getCriteriaSetOfPypType({ ...params, grades });
  };

  const isEmptyCriteria = () => {
    const { getCriteriaSetOfPypType } = props;

    const criteriaExists = checkAchievementCriteriaExists({
      assessmentFields: mappedLearningGoals,
      curriculumProgramType,
      getCriteriaSetOfPypType,
    });

    //Note:removing getIsSubjectStandard({
    //   type: _.get(pypElementMapping, item.fieldUID),
    // }) &&  check as now skills can be rated keeping this for future reference
    return (
      criteriaExists &&
      (!(getIsNewGradingSetupEnabled() && learningCourseId) ||
        !_.some(
          mappedLearningGoals,
          item => _.size(_.get(item, "value", [])) > 0
        ))
    );
  };

  const calculateTotalRatings = () => {
    const elementPYP = _.get(props, "elementPYP", []);
    let length = 0;

    _.forEach(elementPYP, element => {
      const nestedLearningGoalIds = getNestedTaggedLearningGoalsIds(
        element,
        _.get(element, "value", [])
      );

      const criteriaSet = getCriteriaSetBasedOnPlannerElementType({
        type: pypElementMapping[element.fieldUID],
        getCriteriaSetOfPypType: getCriteriaSetOfPypTypeWrapper,
      });

      length +=
        _.get(nestedLearningGoalIds, "length", 0) *
        _.get(criteriaSet, "length", 0);
    });

    return length;
  };

  const totalRatings = calculateTotalRatings();

  const studentSelectionOptions = [
    {
      key: "root",
      tier: 2,
      children: ["student_selection"],
    },
    {
      key: "student_selection",
      children: [
        ..._.map(students, student => _.get(student, "node.id", undefined)),
      ],
      tier: 2,
      title: showLearningGoalsEditor
        ? t(
            isStudentIndividuallyRated
              ? "journal:select_student_to_rate"
              : "journal:list_of_students_rated"
          )
        : "",
      parent: "root",
    },
    ..._.map(students, student => {
      const studentName = getFormattedStudentName({
        student: _.get(student, "node", {}),
        defaultStudentNameOrderPreference,
        isFormattedNameV2: true,
      });
      const studentProfileImage = _.get(
        student,
        "node.profileImage",
        undefined
      );

      const studentNode = _.get(student, "node", {});
      const studentId = _.get(studentNode, "id", null);
      const alertTypes = _.get(studentNode, "alertTypes", []);

      return {
        key: _.get(student, "node.id", undefined),
        title: studentName,
        tier: 1,
        parent: "student_selection",
        children: [],
        isDisabled:
          showLearningGoalsEditor &&
          !isStudentIndividuallyRated &&
          _.size(students, 0) > 1,
        prefix: (
          <Avatar
            id={_.get(student, "node.id", undefined)}
            name={studentName}
            shade={"light"}
            src={studentProfileImage}
            size={"x-small"}
          />
        ),
        suffix: (
          <div className={classes.suffixContainer}>
            <StudentAlerts studentId={studentId} alertTypes={alertTypes} />
            {(isStudentIndividuallyRated || _.size(students, 0) === 1) &&
              !showLearningGoalsPreview &&
              getSuffixTickMark(student, ibPYPElementRatings, totalRatings)}
          </div>
        ),
      };
    }),
  ];

  const [dialogBoxState, setDialogBoxState] = useState({
    showDialogBox: false,
    currentDialogAction: "",
  });

  const [isCancelConfirmed, setIsCancelConfirmed] = useState(false);
  const [activeTerm, setActiveTerm] = useState(currentActiveTerm);

  const DIALOGS_INFO = {
    MOVE_TO_INDIVIDUAL: {
      title: t("journal:rate_students_individually"),
      message: t("journal:rate_together_msg"),
      confirmButtonText: t("journal:rate_individually"),
      button1CancelProps: {
        variant: "outlined-subtle",
        size: "large",
      },
      button2ConfirmProps: {
        variant: "progressive",
        size: "large",
      },
    },
    MOVE_TO_COLLECTIVE: {
      title: t("journal:rate_students_collectively"),
      message: t("journal:rate_individual_msg"),
      warningText: (
        <Checkbox
          isChecked={isCancelConfirmed}
          onChange={value => setIsCancelConfirmed(!isCancelConfirmed)}
        >
          {t("journal:rate_individual_alert")}
        </Checkbox>
      ),
      confirmButtonText: t("journal:rate_collectively"),
      button1CancelProps: {
        variant: "outlined-subtle",
        size: "large",
      },
      button2ConfirmProps: {
        variant: "destructive",
        size: "large",
        disabled: !isCancelConfirmed,
      },
    },
    CANCEL_RATINGS: {
      title: t("common:discard_changes"),
      message: t("journal:cancel_rating_changes_msg"),
      confirmButtonText: t("common:discard_changes"),
      cancelButtonText: t("journal:keep_ratings"),
      button1CancelProps: {
        variant: "outlined-subtle",
        size: "large",
      },
      button2ConfirmProps: {
        variant: "destructive",
        size: "large",
      },
    },
  };

  const dialogueBoxStyles = {
    headerStyles: {
      padding: "24px 24px 14px 32px",
      fontSize: "2rem",
    },
    bodyStyles: {
      padding: "0px 32px",
      fontSize: "1.6rem",
    },
    footerStyles: {
      padding: "24px 32px",
    },
  };

  const theatreModeSyles = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  };

  const moveToIndividualMode = () => {
    setShowCollectiveAlert(false);
    updatePost({
      isStudentIndividuallyRated: true,
      currentSelectedStudentForRating: _.get(students, "[0]", {}),
    });
  };

  const moveToCollectiveMode = () => {
    setIsCancelConfirmed(false);
    setShowCollectiveAlert(true);
    updatePost({
      isStudentIndividuallyRated: false,
      currentSelectedStudentForRating: {},
      ibPYPElementRatings: [],
    });
  };

  const setIndividualRatingMode = switchState => {
    if (switchState == true) {
      if (_.size(ibPYPElementRatings, 0) > 0)
        setDialogBoxState({
          showDialogBox: true,
          currentDialogAction: MOVE_TO_INDIVIDUAL,
        });
      else moveToIndividualMode();
    } else {
      if (_.size(ibPYPElementRatings, 0) > 0)
        setDialogBoxState({
          showDialogBox: true,
          currentDialogAction: MOVE_TO_COLLECTIVE,
        });
      else moveToCollectiveMode();
    }
  };

  const onDialogConfirmClick = () => {
    switch (dialogBoxState?.currentDialogAction) {
      case MOVE_TO_INDIVIDUAL:
        moveToIndividualMode();
        break;

      case MOVE_TO_COLLECTIVE:
        moveToCollectiveMode();
        break;

      case CANCEL_RATINGS:
        onCancelConfirmClick();
        break;
    }
  };
  const onDialogCancelClick = () => {
    setDialogBoxState({ showDialogBox: false });
  };

  const onStudentSelected = selectedStudentId => {
    const selectedStudent = _.find(
      students,
      student => _.get(student, "node.id", undefined) == selectedStudentId
    );
    if (!_.isUndefined(selectedStudent))
      updatePost({ currentSelectedStudentForRating: selectedStudent });
  };

  const onCancelConfirmClick = () => {
    updatePost({
      ibPYPElementRatings: _.cloneDeep(originalibPYPElementRatings),
      isStudentIndividuallyRated: originalIsStudentIndividuallyRated,
    });
    onCloseClick && onCloseClick();
  };

  const onCancelClick = () => {
    if (
      _.size(
        _.differenceWith(
          ibPYPElementRatings,
          originalibPYPElementRatings,
          _.isEqual
        ),
        0
      ) > 0 ||
      _.size(
        _.differenceWith(
          originalibPYPElementRatings,
          ibPYPElementRatings,
          _.isEqual
        ),
        0
      ) > 0
    ) {
      setDialogBoxState({
        showDialogBox: true,
        currentDialogAction: CANCEL_RATINGS,
      });
      return;
    }
    onCloseClick && onCloseClick();
  };

  const onDoneClick = () => {
    updatePost({
      originalibPYPElementRatings: _.cloneDeep(ibPYPElementRatings),
      originalIsStudentIndividuallyRated: isStudentIndividuallyRated,
    });
    onCloseClick && onCloseClick();
  };

  const individuallyRatedStudentClasses = classNames(
    "text-body-1",
    classes.individualSelectedStudent
  );

  const postRateonLearningGoalsModalBody = () => (
    <div
      className={classes.previewModalBody}
      style={{
        borderRadius: showLearningGoalsTheatreModePreview
          ? "0px 0px 16px 16px"
          : "",
      }}
    >
      {!hideStudentSelectionNavigation && (
        <div className={classes.studentSelectionContainer}>
          <SideNavigation
            dsVersion="2.0"
            options={studentSelectionOptions}
            onClick={onStudentSelected}
            containerStyle={{ height: "100%" }}
            selectedOptionKey={_.get(
              currentSelectedStudentForRating,
              "node.id",
              undefined
            )}
            rootKey={"root"}
          />
        </div>
      )}
      <div
        className={classes.previewPypEvaluationContainer}
        style={{
          backgroundColor: showLearningGoalsTheatreModePreview
            ? colors.surfaceWhite
            : "",
        }}
      >
        {currentSelectedStudentForRating != undefined && (
          <div className={classes.selectedStudentProfile}>
            <Avatar
              id={_.get(currentSelectedStudentForRating, "node.id", undefined)}
              shade={"light"}
              size={"small"}
              name={getFormattedStudentName({
                student: _.get(currentSelectedStudentForRating, "node", {}),
                isFormattedNameV2: true,
                defaultStudentNameOrderPreference,
              })}
              src={_.get(
                currentSelectedStudentForRating,
                "node.profileImage",
                undefined
              )}
            />
            <div className={individuallyRatedStudentClasses}>
              {getFormattedStudentName({
                student: _.get(currentSelectedStudentForRating, "node", {}),
                isFormattedNameV2: true,
                defaultStudentNameOrderPreference,
              })}
              <StudentAlerts
                studentId={_.get(
                  currentSelectedStudentForRating,
                  "node.id",
                  ""
                )}
                alertTypes={_.get(
                  currentSelectedStudentForRating,
                  "node.alertTypes",
                  []
                )}
              />
            </div>
          </div>
        )}
        <PypEvaluationV2
          isComplete={true}
          parentId={parentId}
          parentType={"POST"}
          showToggleStudentPypEvaluateStatus={false}
          evaluateIBPYPElements={true}
          studentDetails={_.get(currentSelectedStudentForRating, "node", {})}
          assessmentFields={mappedLearningGoals}
          ibPYPElementRatings={currentRatings}
          isEvaluated={true}
          curriculumProgramType={curriculumProgramType}
          isMinimalDesign={true}
          isJournalPostRating={true}
          showCriteriaDescriptorButton={true}
          course={course}
          learningCourseId={learningCourseId || learningCourseIdFromProps}
        />
      </div>
    </div>
  );

  const headerStyle = {
    fontSize: "1.5rem",
    fontWeight: "500",
    lineHeight: "2.2rem",
  };
  const postRateonLearningGoalsModalHeader = () => (
    <div className={classes.modalHeader}>
      <span className={classes.block}>
        {t("journal:rating_on_learning_goals")}
      </span>
      <span style={headerStyle} className={classes.block}>
        {postAcademicTermLabel}
      </span>
    </div>
  );

  return (
    <React.Fragment>
      {showLearningGoalsPreview ? (
        // --- Preview only ---
        showLearningGoalsTheatreModePreview ? (
          <div style={theatreModeSyles}>
            {postRateonLearningGoalsModalHeader()}
            {postRateonLearningGoalsModalBody()}
          </div>
        ) : (
          <UIModal
            isOpen={showLearningGoalsPreview}
            modalContent={classes.previewModalContainer}
            onRequestClose={onCloseClick}
          >
            <React.Fragment>
              <div className={classes.previewModalHeader}>
                <span>{t("journal:rating_on_learning_goals")}</span>
                <span className={classes.previewModalHeaderRightContainer}>
                  <span style={{ ...headerStyle, alignSelf: "center" }}>
                    {_.get(activeTerm, "label", "")}
                  </span>
                  <IconButton
                    variant={"plain"}
                    size={"medium"}
                    icon={<CloseOutlined />}
                    onClick={onCloseClick}
                  />
                </span>
              </div>
              {postRateonLearningGoalsModalBody()}
            </React.Fragment>
          </UIModal>
        )
      ) : (
        //--- Editor ---
        <UIModal isOpen={showLearningGoalsEditor} isFullScreen={true}>
          <div className={classes.modalBodyContainer}>
            <div className={classes.editorHeader}>
              <div className={isTablet ? "heading-6" : "heading-4"}>
                {t("common:rate_on_learning_goals")}
              </div>
              <div className={classes.editorHeaderRightContainer}>
                {_.size(students, 0) > 1 && !isEmptyCriteria() && (
                  <React.Fragment>
                    <div className={switchTextClass}>
                      {t("journal:rate_students_individually")}
                    </div>
                    <ToggleSwitch
                      checked={isStudentIndividuallyRated}
                      onChange={e =>
                        setIndividualRatingMode(
                          _.get(e, "target.checked", false)
                        )
                      }
                      {...(isTablet ? { size: "xx-small" } : {})}
                    />
                  </React.Fragment>
                )}
                {_.size(currentActiveTerms) > 0 ? (
                  <div
                    className={classes.termContainer}
                    style={{
                      borderLeft:
                        _.size(students, 0) > 1
                          ? `1px solid ${colors.surfaceActive}`
                          : "",
                    }}
                  >
                    <span>{_.get(activeTerm, "label", "")}</span>
                    <Dropdown
                      key={activeTerm?.key}
                      overlay={
                        <DropdownMenu
                          options={currentActiveTerms}
                          selectionType="tick"
                          showSelection
                          value={activeTerm?.key}
                          onClick={({ key }) => {
                            setActiveTerm({
                              key,
                              label: _.get(
                                _.find(currentActiveTerms, { key }),
                                "label"
                              ),
                            });
                            updatePost({ academicTerm: { id: key } });
                          }}
                        />
                      }
                    >
                      <IconButton
                        variant={"plain"}
                        size={"medium"}
                        icon={<CaretDownFilled />}
                        onClick={() => {}}
                      />
                    </Dropdown>
                  </div>
                ) : null}
              </div>
            </div>

            <div className={classes.ratingEditorContainer}>
              <div className={classes.studentSelectionContainer}>
                <SideNavigation
                  dsVersion="2.0"
                  options={studentSelectionOptions}
                  onClick={onStudentSelected}
                  containerStyle={{ height: "100%" }}
                  selectedOptionKey={_.get(
                    currentSelectedStudentForRating,
                    "node.id",
                    undefined
                  )}
                  rootKey={"root"}
                />
              </div>

              <div className={classes.pypEvaluationContainer}>
                {!isEmptyCriteria() ? (
                  <div className={classes.editorContainer}>
                    {!isStudentIndividuallyRated &&
                      showCollectiveAlert &&
                      _.size(students, 0) > 1 && (
                        <div style={{ paddingBottom: "24px" }}>
                          <Alert
                            type={"info"}
                            isClosable={true}
                            message={t("journal:rating_together_with_count", {
                              count: _.size(students, 0),
                            })}
                            onClose={() => setShowCollectiveAlert(false)}
                          />
                        </div>
                      )}
                    {curriculumProgramType === CURRICULUM_TYPE_MYP &&
                      showMypAlert && (
                        <div style={{ paddingBottom: "24px" }}>
                          <Alert
                            type={"warning"}
                            isClosable={true}
                            message={t(
                              "toastMsgs:rating_only_available_for_atl_and_standards_lp"
                            )}
                            onClose={() => setShowMypAlert(false)}
                          />
                        </div>
                      )}

                    {isStudentIndividuallyRated &&
                      currentSelectedStudentForRating != undefined && (
                        <div className={classes.selectedStudentProfile}>
                          <Avatar
                            id={_.get(
                              currentSelectedStudentForRating,
                              "node.id",
                              undefined
                            )}
                            shade={"light"}
                            size={"small"}
                            name={getFormattedStudentName({
                              student: _.get(
                                currentSelectedStudentForRating,
                                "node",
                                {}
                              ),
                              isFormattedNameV2: true,
                              defaultStudentNameOrderPreference,
                            })}
                            src={_.get(
                              currentSelectedStudentForRating,
                              "node.profileImage",
                              undefined
                            )}
                          />
                          <div className={individuallyRatedStudentClasses}>
                            {getFormattedStudentName({
                              student: _.get(
                                currentSelectedStudentForRating,
                                "node",
                                {}
                              ),
                              isFormattedNameV2: true,
                              defaultStudentNameOrderPreference,
                            })}
                            <StudentAlerts
                              studentId={_.get(
                                currentSelectedStudentForRating,
                                "node.id",
                                ""
                              )}
                              alertTypes={_.get(
                                currentSelectedStudentForRating,
                                "node.alertTypes",
                                []
                              )}
                            />
                          </div>
                        </div>
                      )}

                    <PypEvaluationV2
                      isComplete={false}
                      parentId={parentId}
                      parentType={"POST"}
                      showToggleStudentPypEvaluateStatus={false}
                      evaluateIBPYPElements={true}
                      studentDetails={_.get(
                        currentSelectedStudentForRating,
                        "node",
                        {}
                      )}
                      assessmentFields={mappedLearningGoals}
                      isEvaluated={false}
                      curriculumProgramType={curriculumProgramType}
                      isMinimalDesign={true}
                      ibPYPElementRatings={currentRatings}
                      postAllStudentRatings={ibPYPElementRatings}
                      isJournalPostRating={true}
                      course={course}
                      showNodesIfCriteriaEmpty={false}
                      learningCourseId={learningCourseId}
                    />
                  </div>
                ) : (
                  <div className={classes.emptyContainer}>
                    <EmptyState
                      illustration={NoAssignmentIllustration}
                      title={
                        getIsNewGradingSetupEnabled()
                          ? t(
                              "journal:no_evaluation_criteria_header_grade_scales"
                            )
                          : t("journal:no_evaluation_criteria_header")
                      }
                      subtitle={
                        getIsNewGradingSetupEnabled()
                          ? t(
                              "journal:request_admin_assign_evaluation_criteria_grade_scales"
                            )
                          : t(
                              "journal:request_admin_assign_evaluation_criteria"
                            )
                      }
                    />
                  </div>
                )}
                <div className={classes.editorFooter}>
                  <Button
                    variant="outlined-subtle"
                    size={"large"}
                    onClick={onCancelClick}
                  >
                    {t("common:cancel")}
                  </Button>
                  {!isEmptyCriteria() && (
                    <Button
                      variant="progressive"
                      size={"large"}
                      onClick={onDoneClick}
                    >
                      {t("common:done")}
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </UIModal>
      )}
      {dialogBoxState.showDialogBox && (
        <DialogueBoxV2
          modalTitle={DIALOGS_INFO[dialogBoxState.currentDialogAction].title}
          showModal={true}
          onClickButton2={onDialogConfirmClick}
          onClickButton1={onDialogCancelClick}
          toggleDialogueBoxDisplay={onDialogCancelClick}
          modalBody={DIALOGS_INFO[dialogBoxState.currentDialogAction].message}
          warningText={_.get(
            DIALOGS_INFO[dialogBoxState.currentDialogAction],
            "warningText",
            undefined
          )}
          warningTextStyles={warningTextStyles}
          showWarningOnBottom={true}
          button1={_.get(
            DIALOGS_INFO[dialogBoxState.currentDialogAction],
            "cancelButtonText",
            t("common:cancel")
          )}
          button2={
            DIALOGS_INFO[dialogBoxState.currentDialogAction].confirmButtonText
          }
          isPromptBox={false}
          button1Props={{
            ...DIALOGS_INFO[dialogBoxState.currentDialogAction]
              .button1CancelProps,
          }}
          button2Props={{
            ...DIALOGS_INFO[dialogBoxState.currentDialogAction]
              .button2ConfirmProps,
          }}
          size="auto"
          headerStyles={dialogueBoxStyles.headerStyles}
          modalBodyStyle={dialogueBoxStyles.bodyStyles}
          footerContainerStyle={dialogueBoxStyles.footerStyles}
          customModalContentClass={classes.dialogueboxModalContent}
        />
      )}
    </React.Fragment>
  );
};

// Function to map selected learning goals object properties to specific fields, required by <PypEvaluation> component
const getMappedLearningGoals = ({
  elementPYP,
  curriculumProgramType,
  mode,
}) => {
  const data = _.map(elementPYP, element => {
    const newObject = _.cloneDeep(element);
    newObject.uid = newObject.fieldUID;
    newObject.id = newObject.uid;
    if (curriculumProgramType == CURRICULUM_TYPE_PYP) {
      if (_.has(newObject, `resolvedMinimalTree.${[newObject.fieldUID]}`))
        newObject.resolvedMinimalTree[
          pypElementSetMapping[newObject.fieldUID]
        ] = _.get(newObject, `resolvedMinimalTree.${[newObject.fieldUID]}`, {});
    }
    return newObject;
  });
  return data;
};

const getSuffixTickMark = (student, ratings, learningGoalsCount) => {
  if (
    _.size(
      _.filter(
        ratings,
        rating =>
          _.get(rating, "studentId", _.get(rating, "student.id", undefined)) ==
          _.get(student, "node.id", "")
      ),
      0
    ) == learningGoalsCount
  ) {
    return <TickCircleFilled variant="success" size="xx-small" />;
  } else return null;
};

const getMappedLearningGoalsMemoized = _.memoize(
  params => getMappedLearningGoals(params),
  params => {
    const { elementPYP, curriculumProgramType, mode } = params;

    // Create a stable hash key using specific properties
    const elementPYPHash = _.map(
      elementPYP,
      element =>
        `${element.fieldUID}_${_.join(
          _.get(element, "value", BLANK_ARRAY),
          "|"
        )}`
    ).join("|");

    return JSON.stringify(`${elementPYPHash}_${curriculumProgramType}_${mode}`);
  }
);

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const userType = _.get(state, "login.userInfo.user_type", "");
  const isPostStoreInitialized = _.get(state, "post", undefined) != undefined;
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );

  const ibPYPElementRatings = _.get(ownProps, "propsIbPypElementRatings", []);
  const isStudentIndividuallyRated = _.get(
    state,
    "post.postDetails.isStudentIndividuallyRated",
    false
  );
  const originalIsStudentIndividuallyRated = _.get(
    state,
    "post.postDetails.originalIsStudentIndividuallyRated",
    false
  );
  const currentSelectedStudentForRating = isPostStoreInitialized
    ? _.get(
        state,
        "post.postDetails.currentSelectedStudentForRating",
        undefined
      )
    : ownProps?.showLearningGoalsPreview
    ? _.get(ownProps, "students[0]", {})
    : {};

  let currentRatings = [];
  if (
    isStudentIndividuallyRated === true ||
    ownProps.showLearningGoalsPreview === true
  ) {
    currentRatings = _.filter(ibPYPElementRatings, rating => {
      return (
        _.get(rating, "studentId", _.get(rating, "student.id", undefined)) ==
        _.get(currentSelectedStudentForRating, "node.id", undefined)
      );
    });
  } else {
    currentRatings = [...ibPYPElementRatings];
  }

  const mode = _.get(ownProps, "mode", "create");
  const mappedLearningGoals = getMappedLearningGoalsMemoized({
    elementPYP: _.get(ownProps, "elementPYP", []),
    curriculumProgramType: _.get(
      state,
      "platform.currentCurriculumProgram.type",
      "IB_PYP"
    ),
    mode: mode,
  });
  const parentId =
    mode == "edit" ? _.get(state, "post.postDetails.id", undefined) : undefined;
  const grades = state.teacher.selected_class.selected_grades;
  const academicTermId = _.get(
    state,
    "post.postDetails.academicTerm.id",
    undefined
  );
  const postAcademicTerm = _.get(ownProps, "academicTerm", undefined);
  const getFormatDate = date => moment(date).format("Do MMM YYYY");
  const postAcademicTermLabel = postAcademicTerm
    ? `${_.get(postAcademicTerm, "label")} (${getFormatDate(
        postAcademicTerm.startDate
      )} - ${getFormatDate(postAcademicTerm.endDate)})`
    : "";
  const courseId = _.get(state, "teacher.selected_class.selected_course");

  const academicYearId = getSelectedAcademicYearId(state);
  const courseGradeFilters = {
    academicYearId,
  };

  const course = getCourseDetailsFromCache({
    id: courseId,
    courseGradeFilters,
  });
  const currentActiveTerms = _.get(ownProps, "currentActiveTerms", []);
  const curriculumProgramId = _.get(
    state,
    "platform.currentCurriculumProgram.id",
    undefined
  );
  const organizationAcademicYearsVariables = {
    id: userInfo.org_id,
    termsFilters: {
      curriculumProgramIds: curriculumProgramId
        ? [curriculumProgramId]
        : undefined,
    },
  };

  return {
    mappedLearningGoals,
    ibPYPElementRatings,
    isStudentIndividuallyRated,
    originalIsStudentIndividuallyRated,
    currentSelectedStudentForRating,
    currentRatings,
    parentId,
    hideStudentSelectionNavigation:
      userType == "student" ||
      userType == "parent" ||
      ownProps?.hideStudentSelectionNavigation,
    grades,
    course,
    currentActiveTerms,
    organizationAcademicYearsVariables,
    userType,
    academicTermId,
    organizationId: _.get(userInfo, "org_id", undefined),
    showLearningGoalsTheatreModePreview: _.get(
      ownProps,
      "showLearningGoalsTheatreModePreview",
      false
    ),
    postAcademicTermLabel,
    defaultStudentNameOrderPreference,
    learningCourseId: getSelectedLearningCourseId(state),
  };
};

const mapActionCreators = {
  updatePost,
  getCriteriaSetOfPypType,
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["journal", "common"] })
)(PostRateonLearningGoals);
